module.exports = __webpack_public_path__ + "static/media/offerte_white.fce9d8d3.svg";